var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fileUpload-as-button" }, [
    _c(
      "div",
      { staticClass: "fileUpload", class: { disabled: _vm.iniDisabled } },
      [
        _vm.hasFiles && !_vm.hidePreview
          ? _c("span", [
              _c(
                "ul",
                { staticClass: "list-group" },
                [
                  _vm._l(_vm.files, function (file, index) {
                    return _c(
                      "li",
                      { key: index, staticClass: "list-group-item preview" },
                      [
                        _c("div", { staticClass: "image" }, [
                          _c("img", { attrs: { src: file.src } }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "actions" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "is-small is-danger",
                                attrs: { "icon-left": "trash-alt" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeFile(index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("forms.remove")))]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.newFiles, function (file, index) {
                    return _c(
                      "li",
                      {
                        key: 1000 + index,
                        staticClass: "list-group-item preview isNew",
                      },
                      [
                        _c("div", { staticClass: "image" }, [
                          _c("img", { attrs: { src: file.src } }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "actions" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "is-small is-danger",
                                attrs: { "icon-left": "trash-alt" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeNewFile(index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("forms.remove")))]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasFiles && _vm.hidePreview
          ? _c("span", [
              _c(
                "ul",
                { staticClass: "list-group" },
                [
                  _vm._l(_vm.files, function (file, index) {
                    return _c(
                      "li",
                      { key: index, staticClass: "list-group-item" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "is-small is-danger",
                            attrs: { "icon-left": "trash-alt" },
                            on: {
                              click: function ($event) {
                                return _vm.removeFile(index)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("forms.remove")))]
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.newFiles, function (file, index) {
                    return _c(
                      "li",
                      { key: 1000 + index, staticClass: "list-group-item" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "is-small is-danger",
                            attrs: { "icon-left": "trash-alt" },
                            on: {
                              click: function ($event) {
                                return _vm.removeNewFile(index)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("forms.remove")))]
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showAdd
          ? _c(
              "form",
              { attrs: { enctype: "multipart/form-data", novalidate: "" } },
              [
                _c("div", { staticClass: "dropbox" }, [
                  _c("input", {
                    staticClass: "input-file",
                    attrs: {
                      type: "file",
                      disabled: _vm.iniDisabled,
                      multiple: _vm.iniMultiple,
                      accept: _vm.allowedtypes,
                    },
                    on: { change: _vm.handleFileChange },
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.buttonText) +
                        "\n                "
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }